import CircularProgress, { CircularProgressProps } from '@material-ui/core/CircularProgress';
import React, { FC } from 'react'
import useStyles from './styles';

export const JetSpinner: FC<CircularProgressProps> = (props) => {
    const classes = useStyles()
    return (
        <div className={classes.jetSpinnerRoot}>
          <CircularProgress
            variant="determinate"
            className={classes.jetSpinnerBottom}
            size={24}
            thickness={4}
            {...props}
            value={100}
          />
          <CircularProgress
            variant="indeterminate"
            disableShrink
            className={classes.jetSpinnerTop}
            classes={{
              circle: classes.jetSpinnerCircle,
            }}
            size={24}
            thickness={4}
            {...props}
          />
        </div>
      );
}
